module.exports = __webpack_public_path__ + "static/img/YDZF.70c6d30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YDZF.png
// module id = hxQ1
// module chunks = 128